import React from 'react'
import BaseIcon from 'react-icon-base'

const PG = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>PG</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#D21F34" xlinkHref="#a" />
      <path fill="#FCE343" d="M16 5v2l-4-3h3V2l4 3z" mask="url(#b)" />
      <path fill="#292929" d="M0 0v15h21z" mask="url(#b)" />
      <path fill="#C8C8C8" d="M5 12v1H4v-1h1zm1-2v1H5v-1h1zM4 9v1H3V9h1zm3-1v1H6V8h1zM5 6v1H4V6h1z" mask="url(#b)" />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default PG
